module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/service/Frame_4108@2x.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fservice%2FFrame_4108%402x.png
// module id = a6Iy
// module chunks = 93